const orderComment = () => import('@/views/main/order/comment/comment.vue')
export default {
  path: '/main/order/orderComment',
  name: 'orderComment',
  component: orderComment,
  children: []
}
